import React, {FC} from 'react';

import classNames from 'classnames';

import {Price} from 'components/price/price';

import s from './priceItem.scss';

type PropsType = {
    price: number;
    finalPrice?: number;
};

/**
 * Render only price or strikeThrough price with final price
 * @param {PropsType} props - component props
 * @return {React.ReactNode}
 */
export const PriceItem: FC<PropsType> = ({finalPrice, price}) => {
    return (
        <div className={s.container}>
            <span
                className={classNames({
                    [s.strikeThrough]:
                        (finalPrice || Number(finalPrice) === 0) && finalPrice !== price,
                })}
                aria-label="price"
            >
                <Price>{price}</Price>
            </span>
            {(finalPrice || Number(finalPrice) === 0) && finalPrice !== price && (
                <span aria-label="final price">
                    {' '}
                    <Price>{finalPrice}</Price>
                </span>
            )}
        </div>
    );
};
